// extracted by css-extract-rspack-plugin
export default {"root":"d_lpi","descriptionSection":"tkig6"};